import { render, staticRenderFns } from "./AuthFooter.vue?vue&type=template&id=70efc166&"
import script from "./AuthFooter.vue?vue&type=script&lang=ts&"
export * from "./AuthFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports